export const ALL_ORDERS = "All Orders";